import * as React from "react";
const SvgArrowOnboarding = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#7BFBAF", d: "M9.27 17.53 7.52 15.8l5.26-5.26H0V8h12.78L7.52 2.75 9.27 1l8.27 8.27z" }));
export default SvgArrowOnboarding;
